/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  MaschinenAuslastungKumuliert,
  StrategieUmsaetzeKumuliert,
  UmsaetzeKumuliert,
  UmsatzKumuliert,
  UmsatzVerteilung,
} from '../models/index';
import {
    MaschinenAuslastungKumuliertFromJSON,
    MaschinenAuslastungKumuliertToJSON,
    StrategieUmsaetzeKumuliertFromJSON,
    StrategieUmsaetzeKumuliertToJSON,
    UmsaetzeKumuliertFromJSON,
    UmsaetzeKumuliertToJSON,
    UmsatzKumuliertFromJSON,
    UmsatzKumuliertToJSON,
    UmsatzVerteilungFromJSON,
    UmsatzVerteilungToJSON,
} from '../models/index';

export interface KundenRequest {
    filter: string;
}

export interface MaschinenAuslastungRequest {
    jahr: number;
    filter?: string;
}

export interface StatistikKumuliertRequest {
    filter: string;
    kunden?: Array<string>;
}

export interface StatistikKumuliertPrognoseGruppeUmsaetzeRequest {
    idPrognoseGruppe: number;
}

export interface StatistikKumuliertPrognoseGruppeVerteilungRequest {
    idPrognoseGruppe: number;
}

export interface StatistikKumuliertStrategieRequest {
    filter: string;
}

/**
 * StatistikApi - interface
 * 
 * @export
 * @interface StatistikApiInterface
 */
export interface StatistikApiInterface {
    /**
     * 
     * @summary Gibt eine Liste von Kunden für einen angegebenen RSQL-Filter zurück.
     * @param {string} filter Gibt den RSQL-Filter für die gewünschten Kunden an.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatistikApiInterface
     */
    kundenRaw(requestParameters: KundenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>>;

    /**
     * Gibt eine Liste von Kunden für einen angegebenen RSQL-Filter zurück.
     */
    kunden(requestParameters: KundenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>>;

    /**
     * 
     * @summary Lädt die tatsächliche Auslastung von Maschinengruppen für ein Kalenderjahr.
     * @param {number} jahr 
     * @param {string} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatistikApiInterface
     */
    maschinenAuslastungRaw(requestParameters: MaschinenAuslastungRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MaschinenAuslastungKumuliert>>>;

    /**
     * Lädt die tatsächliche Auslastung von Maschinengruppen für ein Kalenderjahr.
     */
    maschinenAuslastung(requestParameters: MaschinenAuslastungRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MaschinenAuslastungKumuliert>>;

    /**
     * 
     * @summary Gibt kumulierte Soll- und Ist-Werte für einen angegebenen RSQL-Filter zurück.
     * @param {string} filter 
     * @param {Array<string>} [kunden] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatistikApiInterface
     */
    statistikKumuliertRaw(requestParameters: StatistikKumuliertRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UmsaetzeKumuliert>>>;

    /**
     * Gibt kumulierte Soll- und Ist-Werte für einen angegebenen RSQL-Filter zurück.
     */
    statistikKumuliert(requestParameters: StatistikKumuliertRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UmsaetzeKumuliert>>;

    /**
     * 
     * @summary Gibt die pro Jahr und Firma kumulierten Umsätze einer Prognosegruppe zurück.
     * @param {number} idPrognoseGruppe 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatistikApiInterface
     */
    statistikKumuliertPrognoseGruppeUmsaetzeRaw(requestParameters: StatistikKumuliertPrognoseGruppeUmsaetzeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UmsatzKumuliert>>>;

    /**
     * Gibt die pro Jahr und Firma kumulierten Umsätze einer Prognosegruppe zurück.
     */
    statistikKumuliertPrognoseGruppeUmsaetze(requestParameters: StatistikKumuliertPrognoseGruppeUmsaetzeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UmsatzKumuliert>>;

    /**
     * 
     * @summary Gibt die Soll-Umsatzverteilungen einer Prognosegruppe in Prozent zurück.
     * @param {number} idPrognoseGruppe 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatistikApiInterface
     */
    statistikKumuliertPrognoseGruppeVerteilungRaw(requestParameters: StatistikKumuliertPrognoseGruppeVerteilungRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UmsatzVerteilung>>>;

    /**
     * Gibt die Soll-Umsatzverteilungen einer Prognosegruppe in Prozent zurück.
     */
    statistikKumuliertPrognoseGruppeVerteilung(requestParameters: StatistikKumuliertPrognoseGruppeVerteilungRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UmsatzVerteilung>>;

    /**
     * 
     * @summary Gibt kumulierte Strategie-Umsätze für einen angegebenen RSQL-Filter zurück.
     * @param {string} filter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatistikApiInterface
     */
    statistikKumuliertStrategieRaw(requestParameters: StatistikKumuliertStrategieRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StrategieUmsaetzeKumuliert>>>;

    /**
     * Gibt kumulierte Strategie-Umsätze für einen angegebenen RSQL-Filter zurück.
     */
    statistikKumuliertStrategie(requestParameters: StatistikKumuliertStrategieRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StrategieUmsaetzeKumuliert>>;

}

/**
 * 
 */
export class StatistikApi extends runtime.BaseAPI implements StatistikApiInterface {

    /**
     * Gibt eine Liste von Kunden für einen angegebenen RSQL-Filter zurück.
     */
    async kundenRaw(requestParameters: KundenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.filter === null || requestParameters.filter === undefined) {
            throw new runtime.RequiredError('filter','Required parameter requestParameters.filter was null or undefined when calling kunden.');
        }

        const queryParameters: any = {};

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_auth", []);
        }

        const response = await this.request({
            path: `/api/v1/statistik/kunden`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Gibt eine Liste von Kunden für einen angegebenen RSQL-Filter zurück.
     */
    async kunden(requestParameters: KundenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.kundenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lädt die tatsächliche Auslastung von Maschinengruppen für ein Kalenderjahr.
     */
    async maschinenAuslastungRaw(requestParameters: MaschinenAuslastungRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MaschinenAuslastungKumuliert>>> {
        if (requestParameters.jahr === null || requestParameters.jahr === undefined) {
            throw new runtime.RequiredError('jahr','Required parameter requestParameters.jahr was null or undefined when calling maschinenAuslastung.');
        }

        const queryParameters: any = {};

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_auth", []);
        }

        const response = await this.request({
            path: `/api/v1/statistik/maschinenAuslastung/{jahr}`.replace(`{${"jahr"}}`, encodeURIComponent(String(requestParameters.jahr))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MaschinenAuslastungKumuliertFromJSON));
    }

    /**
     * Lädt die tatsächliche Auslastung von Maschinengruppen für ein Kalenderjahr.
     */
    async maschinenAuslastung(requestParameters: MaschinenAuslastungRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MaschinenAuslastungKumuliert>> {
        const response = await this.maschinenAuslastungRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gibt kumulierte Soll- und Ist-Werte für einen angegebenen RSQL-Filter zurück.
     */
    async statistikKumuliertRaw(requestParameters: StatistikKumuliertRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UmsaetzeKumuliert>>> {
        if (requestParameters.filter === null || requestParameters.filter === undefined) {
            throw new runtime.RequiredError('filter','Required parameter requestParameters.filter was null or undefined when calling statistikKumuliert.');
        }

        const queryParameters: any = {};

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        if (requestParameters.kunden) {
            queryParameters['kunden'] = requestParameters.kunden;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_auth", []);
        }

        const response = await this.request({
            path: `/api/v1/statistik/kumuliert`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UmsaetzeKumuliertFromJSON));
    }

    /**
     * Gibt kumulierte Soll- und Ist-Werte für einen angegebenen RSQL-Filter zurück.
     */
    async statistikKumuliert(requestParameters: StatistikKumuliertRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UmsaetzeKumuliert>> {
        const response = await this.statistikKumuliertRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gibt die pro Jahr und Firma kumulierten Umsätze einer Prognosegruppe zurück.
     */
    async statistikKumuliertPrognoseGruppeUmsaetzeRaw(requestParameters: StatistikKumuliertPrognoseGruppeUmsaetzeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UmsatzKumuliert>>> {
        if (requestParameters.idPrognoseGruppe === null || requestParameters.idPrognoseGruppe === undefined) {
            throw new runtime.RequiredError('idPrognoseGruppe','Required parameter requestParameters.idPrognoseGruppe was null or undefined when calling statistikKumuliertPrognoseGruppeUmsaetze.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_auth", []);
        }

        const response = await this.request({
            path: `/api/v1/statistik/kumuliert/{idPrognoseGruppe}/umsatz`.replace(`{${"idPrognoseGruppe"}}`, encodeURIComponent(String(requestParameters.idPrognoseGruppe))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UmsatzKumuliertFromJSON));
    }

    /**
     * Gibt die pro Jahr und Firma kumulierten Umsätze einer Prognosegruppe zurück.
     */
    async statistikKumuliertPrognoseGruppeUmsaetze(requestParameters: StatistikKumuliertPrognoseGruppeUmsaetzeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UmsatzKumuliert>> {
        const response = await this.statistikKumuliertPrognoseGruppeUmsaetzeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gibt die Soll-Umsatzverteilungen einer Prognosegruppe in Prozent zurück.
     */
    async statistikKumuliertPrognoseGruppeVerteilungRaw(requestParameters: StatistikKumuliertPrognoseGruppeVerteilungRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UmsatzVerteilung>>> {
        if (requestParameters.idPrognoseGruppe === null || requestParameters.idPrognoseGruppe === undefined) {
            throw new runtime.RequiredError('idPrognoseGruppe','Required parameter requestParameters.idPrognoseGruppe was null or undefined when calling statistikKumuliertPrognoseGruppeVerteilung.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_auth", []);
        }

        const response = await this.request({
            path: `/api/v1/statistik/kumuliert/{idPrognoseGruppe}/verteilung`.replace(`{${"idPrognoseGruppe"}}`, encodeURIComponent(String(requestParameters.idPrognoseGruppe))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UmsatzVerteilungFromJSON));
    }

    /**
     * Gibt die Soll-Umsatzverteilungen einer Prognosegruppe in Prozent zurück.
     */
    async statistikKumuliertPrognoseGruppeVerteilung(requestParameters: StatistikKumuliertPrognoseGruppeVerteilungRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UmsatzVerteilung>> {
        const response = await this.statistikKumuliertPrognoseGruppeVerteilungRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gibt kumulierte Strategie-Umsätze für einen angegebenen RSQL-Filter zurück.
     */
    async statistikKumuliertStrategieRaw(requestParameters: StatistikKumuliertStrategieRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StrategieUmsaetzeKumuliert>>> {
        if (requestParameters.filter === null || requestParameters.filter === undefined) {
            throw new runtime.RequiredError('filter','Required parameter requestParameters.filter was null or undefined when calling statistikKumuliertStrategie.');
        }

        const queryParameters: any = {};

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2_auth", []);
        }

        const response = await this.request({
            path: `/api/v1/statistik/kumuliert/strategie`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StrategieUmsaetzeKumuliertFromJSON));
    }

    /**
     * Gibt kumulierte Strategie-Umsätze für einen angegebenen RSQL-Filter zurück.
     */
    async statistikKumuliertStrategie(requestParameters: StatistikKumuliertStrategieRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StrategieUmsaetzeKumuliert>> {
        const response = await this.statistikKumuliertStrategieRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
